import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/semantic.min.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import { faUsers } from '@fortawesome/free-solid-svg-icons'

import {
  BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';


// outdated機能、デザイン
// ずんこちゃんに喋らせる --> 左下
class Zunko extends React.Component {

  getClusterStatus() {
    const availableHosts = Object.values(this.props.availability).map(x => x ? 1 : 0).reduce(function (a, x) { return a + x; })
    const ratio = availableHosts / Object.keys(this.props.availability).length
    if (ratio < 0.1 ) {
      return "めっちゃ空いてますやん"
    } else if (ratio < 0.6) {
      return "結構埋まってますやん"
    } else {
      return "めっちゃ混んでますやん"
    }
  }

  render() {
    return (
      <div className="ui divided items">
        <div className="item">
          <div className="ui tiny image">
            <img src={process.env.PUBLIC_URL + "/zunko.png"} />
          </div>
          <div className="middle aligned content">
            <hgroup className="speech-bubble">
              <h3>{"ずんこちゃんいわく..."}</h3>
              <span>{this.getClusterStatus()}</span>
            </hgroup>
          </div>
        </div>
      </div>
    );
  }
}

class Card extends React.Component {

  getAvailability() {
    const usedGPU = this.props.usage.gpu
      .map(x => x.used_memory > 30 ? 1 : 0)
      .reduce(function (a, x) { return a + x; });
    const totalGPU = this.props.usage.gpu.length

    if (usedGPU === totalGPU) {
      return 'red'
    } else if (usedGPU === 0) {
      return 'blue'
    } else {
      return 'orange'
    }
  }

  isOutDated() {
    const timeStamp = this.props.usage.timestamp
    const updatedTime = new Date(timeStamp);
    const currentTime = new Date();
    const diffMinute = (currentTime.getTime() - updatedTime.getTime()) / (1000 * 60);

    // データが5分以上更新されてなかったらカードの色を変える
    if (diffMinute >= 5) {
      return true
    } else {
      return false
    }
  }

  render() {
    const gpuName = this.props.gpuName

    if (!this.props.usage) {
      return <div />
    }

    const cudaVersion = this.props.usage.cuda_version
    const driverVersion = this.props.usage.driver_version
    const totalMemory = this.props.usage.gpu[0].total_memory
    const users = Array.from(new Set(this.props.usage.gpu.map(x => x.users).flat())).join(', ')
    const timeStamp = this.props.usage.timestamp
    const maybeTransparent = this.isOutDated() ? "transparent" : ""
    // console.log(maybeTransparent)

    return (
      <div className="column">
        <div className={"ui segments " + maybeTransparent}>
          <div className={"ui segment tertiary inverted " + this.getAvailability()}>
            <h3> {gpuName} </h3>
          </div>

          <div className="ui segment">
            <ResponsiveContainer width="100%" height={150}>
              <BarChart data={this.props.usage.gpu} layout="vertical"
                margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" domain={[0, totalMemory]} />
                <YAxis type="category" dataKey="index" />
                {/* いつかここにカスタムラベルを突っ込みたい */}
                <Tooltip />
                <Bar dataKey="used_memory" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="ui segment"> <span><FontAwesomeIcon icon={faClock} /></span> {timeStamp} </div>
          <div className="ui segment"> <span><FontAwesomeIcon icon={faUsers} /></span>{users} </div>

          <div className="ui segments horizontal">
            <div className="ui segment">
              {"CUDA: " + cudaVersion}
            </div>
            <div className="ui segment">
              {"Nvidia-driver: " + driverVersion}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Field extends React.Component {
  constructor(props) {
    super(props);
    const hostNames = ['adnis00', 'adnis01', 'adnis02']
    const gpuInfo = {
      adnis00: this.getGPUInfo("adnis00"),
      adnis01: this.getGPUInfo("adnis01"),
      adnis02: this.getGPUInfo("adnis02")
    }
    const availability = {
      adnis01: false,
      adnis02: false,
      adnis03: false
    }
    // なんか順番がおかしい気がするが。
    this.state = {
      hostNames: hostNames,
      gpuInfo: gpuInfo,
      availability: availability
    };
  }

  renderCard(gpuName, usage) {
    return <Card gpuName={gpuName} usage={usage} />
  }

  renderZunko(availability) {
    return <Zunko availability={availability} />
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.getAllGPUUsage(), 30000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  getAllGPUUsage() {
    this.state.hostNames.forEach(hostname => this.getGPUInfo(hostname))
  }

  isGPUAvailable(data) {
    const usedGPU = data.gpu.map(x => x.used_memory > 30 ? 1 : 0)
      .reduce(function (a, x) { return a + x; });
    const totalGPU = data.gpu.length

    if (usedGPU === totalGPU) {
      return false
    } else {
      return true
    }
  }

  getGPUInfo(hostname) {
    const query = '/gpu/' + hostname
    fetch(query)
      .then(response => response.json())
      .then(data => {
        this.setState(prevState => {
          // TODO: ここのdataがnullの場合のhandling
          let currentState = Object.assign({}, prevState);

          // update gpu usage
          currentState.gpuInfo[hostname] = data.body;

          // update gpu availability
          const isAvailable = this.isGPUAvailable(data.body);
          currentState.availability[hostname] = isAvailable;

          return { currentState };
        })
      });
  }

  render() {
    return (
      <div>
        <div className="ui grid container">
          {this.renderZunko(this.state.availability)}
        </div>
        <div className="ui three column doubling stackable grid container">
          {this.renderCard(this.state.hostNames[0], this.state.gpuInfo[this.state.hostNames[0]])}
          {this.renderCard(this.state.hostNames[1], this.state.gpuInfo[this.state.hostNames[1]])}
          {this.renderCard(this.state.hostNames[2], this.state.gpuInfo[this.state.hostNames[2]])}
          {/* {this.renderCard(this.state.hostNames[1])}
          {this.renderCard(this.state.hostNames[2])} */}
        </div>
      </div>
    );
  }
}

// ========================================

ReactDOM.render(
  <Field />,
  document.getElementById('root')
);

